<script>
    import ForgotPwd from "../../Pages/Auth/ForgotPwd.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <ForgotPwd />
</div>
